import { i18n } from '@/plugins/i18n';

export default () => ({
    title: i18n.t('main.modal.title'),
    cancelVariant: 'light',
    buttonSize: 'sm',
    okTitle: i18n.t('main.buttons.yes'),
    okVariant: 'success',
    cancelTitle: i18n.t('main.buttons.no'),
    footerClass: 'confirm-footer',
    hideHeaderClose: false,
    centered: true,
    headerCloseContent: '',
    headerClass: 'pl-0',
    bodyClass: 'pl-0',
});